// mmin nishab zakat umum (penghasilan)
export const minNishabZakat = 0.025

export const goldPrice = 751000

// Minimal nishab untuk zakat maal
export const minMaal = 79738415

export let typesFund = {
	zakat: [
		{
			id: 'penghasilan',
			label: 'Zakat Profesi'
		},
		{
			id: 'maal',
			label: 'Zakat Harta'
		},
		{
			id: 'perdagangan',
			label: 'Zakat Perdagangan'
		},
		{
			id: 'simpanan',
			label: 'Zakat Simpanan'
		}
	],
	infaq: [
		{
			id: 'infaq',
			label: 'Infaq'
		}
	],
	zx_berbagi: [
		{
			id: 'zx_berbagi',
			label: 'ZX Berbagi'
		}
	],
	fidyah: [
		{
			id: 'fidyah',
			label: 'Fidyah'
		}
	]
}